import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ContainerStyled = styled(Box)({
  textAlign: 'center',
  margin: 'auto',
  border: '2px solid #fbbd08',
  backgroundColor: '#fff7e6',
  padding: '20px',
  borderRadius: '10px',
  maxWidth: '70%',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
});

export const MessageContainerStyled = styled(Box)({
  margin: '15px 0',
});
